const firebaseConfig = {
    apiKey: "AIzaSyDO5oZxluFy7ukorOqOJYzKo1sE2CKaeuQ",
    authDomain: "freshvally-98377.firebaseapp.com",
    projectId: "freshvally-98377",
    storageBucket: "freshvally-98377.appspot.com",
    messagingSenderId: "1051312343810",
    appId: "1:1051312343810:web:7d360a95469fea63f4901b"
  };
  export default firebaseConfig;